import React, { PureComponent, Fragment } from 'react';
import { Table, Modal, ModalBody, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { string, number, array } from 'prop-types';
import PostbackLogsItem from './PostbackLogsItem';

class PostbackLogs extends PureComponent {
  static propTypes = {
    logs: array.isRequired,
    error: string,
  };

  static defaultProps = {
    logs: [],
    error: '',
  };

  state = {
    open: false,
    message: '',
    sortMethod: '',
  };

  toggleModal = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  showDetailedMessage = message => {
    this.setState(() => ({ open: true, message }));
  };

  clearMessage = () => {
    this.setState(() => ({ message: '' }));
  };

  // sortByDate = (order) => {
  //   const { logs } = this.props;

  //   if (order === 'top' || order === '') {
  //     this.setState({ sortMethod: 'bottom' });

  //     const sortedLogs = logs.sort((a, b) => {
  //       if (a.its > b.its) {
  //         return -1;
  //       }

  //       if (a.its < b.its) {
  //         return 1;
  //       }
  //       return 0;
  //     })

  //     this.setState({ logs: sortedLogs })
  //   }

  //   if (order === 'bottom') {
  //     this.setState({ sortMethod: 'top' });
  //     return logs.sort((a, b) => {
  //       if (a.its > b.its) {
  //         return 1;
  //       }

  //       if (a.its < b.its) {
  //         return -1;
  //       }
  //       return 0;
  //     })
  //   }
  // }

  render() {
    const { error, settings, logs } = this.props;
    const { hash, date, url, status, sended, received, leadID, method } = settings;
    const { open, message, sortMethod } = this.state;
    return (
      <Fragment>
        <Table className="postback-logs-table" responsive>
          <thead>
            <tr>
              {hash && <th>ID</th>}
              {leadID && <th><FormattedMessage id="postback.logs.leadID" defaultMessage="Order number" /></th>}
              {date && <th>
                <FormattedMessage id="postback.logs.date" defaultMessage="Date" />
              </th>}
              {url && <th>URL</th>}
              {sended && <th>
                <FormattedMessage id="postback.logs.sent3" defaultMessage="Settings of the request" />
              </th>}
              {method && <th>
                <FormattedMessage id="postback.logs.method" defaultMessage="Postback method" />
              </th>}
              {received && <th>
                <FormattedMessage id="postback.logs.received3" defaultMessage="Response to the request" />
              </th>}
              {status && <th>
                <FormattedMessage id="postback.logs.status" defaultMessage="Status" />
              </th>}
              {/* <th>ID</th> */}
            </tr>
          </thead>

          <tbody>
            {logs.length > 0 ? (
              logs.map(log => (
                <PostbackLogsItem settings={settings} key={log.hash} {...log} onShowMore={this.showDetailedMessage} />
              ))
            ) : (
                <tr className="no-data">
                  <td colSpan="7">
                    {error ? error : <FormattedMessage id="main.no-data" defaultMessage="No Data" />}
                  </td>
                </tr>
              )}
          </tbody>
        </Table>

        <Modal
          className="modal-message"
          isOpen={open}
          toggle={this.toggleModal}
          onClosed={this.clearMessage}
          size="lg"
        >
          <ModalBody>
            <pre className="no-margin">{message}</pre>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default PostbackLogs;
